
export enum EIntegrationsIds {
    CERTIFICATES = 'certificates',
    INVOICE = 'invoice',
    CREDENTIALS = 'credentials',
}

export const integrationsPageFragments = [
    {
        title: 'SETTINGS.INTEGRATIONS.CERTIFICATE.CERTIFICATES',
        id: EIntegrationsIds.CERTIFICATES,
    },
    {
        title: 'SETTINGS.INTEGRATIONS.INVOICE.INVOICE',
        id: EIntegrationsIds.INVOICE,
    },
    {
        title: 'SETTINGS.INTEGRATIONS.CREDENTIALS.REGISTRATION_AT_CITY_HALL',
        id: EIntegrationsIds.CREDENTIALS,
    },
];